export default __webpack_public_path__ + "5be0e0edc359f4c471e0838839194eab.svg";